// extracted by mini-css-extract-plugin
export default {"wrap":"Cart-module__wrap___DXLlF","long":"Cart-module__long___dcsNB","fakeItems":"Cart-module__fakeItems___nlqjr","sticky":"Cart-module__sticky___b9pVC"};